import React from 'react';

import CenteredContainer from 'components/CenteredContainer';

const DashboardSkeleton = () => (
  <CenteredContainer>
    <div className="fixed top-0 md:top-[50px] left-0 w-full px-4 py-2 md:py-6 bg-white shadow-sm z-50 h-[40px] md:h-[65px]" />
    <div className="animate-pulse pt-[90px] md:pt-[180px] -mt-[90px] pb-20 md:w-[630px] md:mx-auto">
      <div className="flex">
        <div className="w-[80px]">
          <div className="aspect-ratio-4-5 rounded-lg shadow-xl overflow-hidden bg-gray-200" />
        </div>
        <div className="flex-1 flex flex-col justify-center pl-4">
          <div className="w-[60%] text-2xl flex items-center col-span-3 h-[20px] bg-gray-200" />
          <div className="mt-2 w-[30%] text-2xl flex items-center col-span-3 h-[15px] bg-gray-200" />
        </div>
      </div>
      <div className="mt-16 text-2xl flex items-center col-span-3 h-[40px] bg-gray-200 rounded-xl" />
      <div className="mt-12 text-2xl flex items-center col-span-3 h-[80px] bg-gray-200 rounded-xl" />
      <div className="mt-6 text-2xl flex items-center col-span-3 h-[130px] bg-gray-200 rounded-xl" />
      <div className="mt-6 text-2xl flex items-center col-span-3 h-[130px] bg-gray-200 rounded-xl" />
    </div>
  </CenteredContainer>
);

export default DashboardSkeleton;
